import {
    IDocument,
    IEntity,
} from '@kurtosys/ksys-api-client/dist/models/commonTypes';
import {
    IQueryOptions,
    IQueryContext,
} from '@kurtosys/ksys-app-template/dist/models/query';
import { isObject } from '@kurtosys/ksys_utils';
import { ShareClassDocument } from '../../models/entity';
import { DataStore } from '../../stores';
import getQueryResults from './getQueryResults';

export default function getDocumentEntityQueryResults(
    query: IQueryOptions,
    document: IDocument,
    documents: Array<ShareClassDocument>,
    culture: string,
    dataStore: DataStore,
    shareClass: IEntity
): string {
    const { entityType } = query;

    if (dataStore) {
        const { documentEntityData, config, appDataProps } = dataStore;
        const documentEntityKeys = config.globalDocumentEntityKeys;

        const queryContext: IQueryContext = {
            ...documentEntityData,
            entityByType: {
                [entityType]: {
                    ...shareClass,
                    documents,
                },
            },
            document,
        };

        const queryResult = getQueryResults(
            queryContext,
            {
                value: query,
            },
            culture,
            appDataProps,
            null,
            documentEntityKeys
        );

        const { value } = queryResult;

        if (isObject(value)) {
            const { _fields = query.placeholder } = value;
            return _fields;
        }

        return value;
    }
}



// WEBPACK FOOTER //
// ./src/utils/query/getDocumentEntityQueryResults.ts